import React, { Component } from "react";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import CachedSharpIcon from "@material-ui/icons/CachedSharp";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import ChevronRightSharpIcon from "@material-ui/icons/ChevronRightSharp";
import ArrowForwardSharpIcon from "@material-ui/icons/ArrowForwardSharp";
import { FormControl, InputGroup, Card, Form, Accordion, Button, Dropdown } from "react-bootstrap";

import axiosRequest from "axios";
import axios from "../../../axios";
import apiError from "../../../error";
import { getDate } from "../../../function";
import Loader from "../../../component/loader/loader";
import CampaignPreview from "../../../component/create-template/campaign-preview/campaign-preview";
import "./test-result.css";
import AiVishingTranscript from "../../../component/ai-vishing-transcript/ai-vishing-transcript";
import AiChatTranscript from "../../../component/ai-chat-transcript/ai-chat-transcript";

var cancelRequest = undefined, CancelToken = axiosRequest.CancelToken;
export default class CampaignList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			count: 0,
			limit: 10,
			search: "",
			results: [],
			loading: true,
			activePage: 1,
			resultId: null,
			attackTypes: [],
			attackTypeId: 0,
			campaignTemplateId: 0,
			attacktypeName: this.useQuery().get("attackTypeId") ? this.useQuery().get("attackTypeId") : "",
			targetInteractionType: "inbound",
			showPreview: false,
			campaignType: null,
		};
		this.loadAttackType();
	}

	useQuery = () => {
		return new URLSearchParams(window.location.search);
	};

	loadAttackType = () => {
		axios
			.get("/api/attacktypes", {})
			.then((res) => {
				if (res.data.attackTypes && res.data.attackTypes.length) {
					let attackTypeId = res.data.attackTypes[0].id;
					let attacktypeName = res.data.attackTypes[0].name;
					for (let i = 0; i < res.data.attackTypes.length; i++) {
						if (this.state.attacktypeName === res.data.attackTypes[i].name) {
							attackTypeId = res.data.attackTypes[i].id;
							attacktypeName = res.data.attackTypes[i].name;
						}
					}
					this.setState({
						attackTypeId: attackTypeId,
						attacktypeName: attacktypeName,
						attackTypes: res.data.attackTypes,
					},
						() => {
							this.load();
						}
					);
				}
			})
			.catch((err) => apiError(err));
	};

	load = async () => {
		// await this.setState({ loading: true });
		if (cancelRequest) cancelRequest();
		axios
			.get("/api/results/test", {
				params: {
					limit: this.state.limit,
					search: this.state.search,
					page: this.state.activePage,
					attackTypeId: this.state.attackTypeId,
				},
				cancelToken: new CancelToken(function executor(c) {
					cancelRequest = c;
				}),
			})
			.then(async (res) => {
				this.setState({
					loading: false,
					count: res.data.count,
					results: res.data.results,
				});
			})
			.catch((error) => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ campaigns: [], count: 0, loading: false });
					apiError(error);
				}
			});
	};

	handleActiveResult = (resultId) => {
		if (resultId) {
			if (this.state.resultId === resultId) {
				this.setState({ resultId: null });
			} else {
				this.setState({ resultId: resultId });
			}
		}
	};

	onButtonClick = (eventId) => {
		document.getElementById(eventId).click();
	};

	handleAttackType = (e) => {
		var attackTypes = this.state.attackTypes;
		let attackTypeId = attackTypes[0].id;
		let attacktypeName = attackTypes[0].name;
		for (let i = 0; i < attackTypes.length; i++) {
			if (parseInt(e.target.value, 10) === attackTypes[i].id) {
				attackTypeId = attackTypes[i].id;
				attacktypeName = attackTypes[i].name;
			}
		}
		this.setState({
			attackTypeId,
			attacktypeName
		}, () => {
			this.load();
		});
	};
	parseDetails = (details) => {
		try {
			return typeof details === 'string' ? JSON.parse(details) : details;
		} catch {
			return null;
		}
	};

	/**
	 * WhatsApp: Email column shows "-" when `email` is numeric only; show the value when it is a real email / text.
	 * Phone column prefers `phone`; if empty and `email` is numeric, show that number under Phone.
	 */
	getEmailPhoneContactColumns = (result) => {
		const isEmpty = (v) =>
			v === undefined ||
			v === null ||
			v === "" ||
			v === "-" ||
			(typeof v === "string" && v.trim() === "");

		const phoneRaw = result.phone;
		const emailRaw = result.email;

		const phoneStr = isEmpty(phoneRaw) ? "" : String(phoneRaw).trim();
		const emailStr = isEmpty(emailRaw) ? "" : String(emailRaw).trim();

		const isNumericOnlyEmail = (raw, str) => {
			if (raw !== undefined && raw !== null && typeof raw === "number" && !Number.isNaN(raw)) {
				return true;
			}
			return str.length > 0 && /^\d+$/.test(str);
		};

		const emailCol =
			!emailStr ? "-" : isNumericOnlyEmail(emailRaw, emailStr) ? "-" : emailStr;

		if (phoneStr) {
			return { emailCol, phoneCol: phoneStr };
		}

		if (emailStr && isNumericOnlyEmail(emailRaw, emailStr)) {
			return { emailCol: "-", phoneCol: emailStr };
		}

		return {
			emailCol,
			phoneCol: phoneStr || "-",
		};
	};

	render() {
		return (
			<div className="content-wrap">
				<div className="breadcrumbbar">
					<div className="flexRow row">
						<div className="col-md-4">
							<div className="page-head d-flex align-items-center justify-content-between">
								<h4 className="page-title"><a href="" onClick={(e) => this.props.history.push("/campaign/test-campaign")} className="bar_Icons mr-2"><ArrowBackSharpIcon className="btn-icon" /></a>Test Results</h4>
							</div>
						</div>
						<div className="col-md-8"> </div>
					</div>
				</div>
				

				<div className="contentbar campListGrids">
				<div className="filter-without-border">
					<div className="align-items-center row">
						<div className="col-md-3 ">
							<div className="positionSearchIcon">
								<InputGroup className="search-wrap">
									<FormControl type="text" placeholder="Search" value={this.state.search}
										onChange={(e) => this.setState({ search: e.target.value, activePage: 1 }, () => this.load())}
										className="inputSearch mr-sm-2 form-control"
									/>
									<SearchSharpIcon className="search-icon"></SearchSharpIcon>
								</InputGroup>
							</div>
						</div>

						<div className="col-sm-9 ">

							<div className="rightFilters">
								<CachedSharpIcon className="btn-icon mr-2" onClick={e => this.setState({ loading: true }, () => this.load())} />

								<Dropdown className="mr-2">
									<Dropdown.Toggle variant="secondary" id="attack-type-dropdown" className="dropdown-color-white">
										{this.state.attackTypes.length > 0 && this.state.attackTypeId
											? this.state.attackTypes.find(a => a.id === this.state.attackTypeId)?.name || this.state.attackTypes[0].name
											: this.state.attackTypes.length > 0 ? this.state.attackTypes[0].name : 'Select Attack Type'
										}
									</Dropdown.Toggle>
									<Dropdown.Menu>
										{this.state.attackTypes.map((attacktype, index) => (
											<Dropdown.Item
												key={index}
												onClick={() => {
													this.setState({
														attackTypeId: attacktype.id,
														attacktypeName: attacktype.name
													}, () => {
														this.load();
													});
												}}
												active={this.state.attackTypeId === attacktype.id}
											>
												{attacktype.name}
											</Dropdown.Item>
										))}
									</Dropdown.Menu>
								</Dropdown>

								<Dropdown className="d-inline-block">
									<Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white">
										{this.state.limit}
									</Dropdown.Toggle>
									<Dropdown.Menu>
										{[10, 25, 50, 100].map((limit) => (
											<Dropdown.Item
												key={`limit-${limit}`}
												onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
												active={this.state.limit === limit}
											>
												{limit}
											</Dropdown.Item>
										))}
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>
				</div>
					<div className="page-content" id="test-result">
						<div className="row TableHead mx-0">
							<div className="col-md-1 expandGrid">#</div>
							{(this.state.attacktypeName === "Vishing" || this.state.attacktypeName === "WhatsApp")?
								<>
									<div className="col-md-2">Email</div> 
									<div className="col-md-2">Phone</div> 
								</>:
								<div className="col-md-3">
									{this.state.attacktypeName === "Phishing" ||
										this.state.attacktypeName === "Ransomware" ||
										this.state.attacktypeName === "Attachment" ||
										this.state.attacktypeName === "QRcode"
										? "Email"
										: "Phone"}
								</div>

							}
							<div className="col-md-2">CreatedAt</div>
							<div className="col-md-2">Status</div>
							<div className="col-md-2">Template</div>
							<div className="col-md-1">Action</div>
						</div>
						<Accordion className="test-result-wrap">
							{this.state.results && this.state.results.length ? (
								this.state.results.map((res, index) => {
									const { result, events } = res;
									const emailPhoneContact =
										this.state.attacktypeName === "WhatsApp" || this.state.attacktypeName === "Vishing"
											? this.getEmailPhoneContactColumns(result)
											: null;
									return (
										<Card key={index}>
											<Accordion.Toggle
												eventKey={index.toString()}
												className={this.state.resultId === result.id ? "active f-toggle" : "f-toggle"}
												onClick={(e) => this.handleActiveResult(result.id)}
											>
												<div className="row">
													<div className="col-md-1 expandGrid">
														<ChevronRightSharpIcon className="right-arrow"></ChevronRightSharpIcon>
													</div>
													{(this.state.attacktypeName==="Vishing" || this.state.attacktypeName==="WhatsApp")?
														<>
															<div className="col-md-2">
																{(this.state.attacktypeName === "WhatsApp" || this.state.attacktypeName === "Vishing") && emailPhoneContact
																	? emailPhoneContact.emailCol
																	: result.email}
															</div>
															<div className="col-md-2">
																{(this.state.attacktypeName === "WhatsApp" || this.state.attacktypeName === "Vishing") && emailPhoneContact
																	? emailPhoneContact.phoneCol
																	: result.phone}
															</div>
														</>:
														<div className="col-md-3">
															{this.state.attacktypeName === "Phishing" ||
																this.state.attacktypeName === "Ransomware" ||
																this.state.attacktypeName === "Attachment" ||
																this.state.attacktypeName === "QRcode"
																? result.email : result.email.startsWith("+") ? result.email : "+" + result.email}
														</div>
													}
													
													<div className="col-md-2">{getDate(result.createdAt)}</div>
													{result.status === "Email Sent" ||
														result.status === "SMS Sent" ||
														result.status === "Message Sent" ||
														result.status === "Call Initiated" ||
														result.status === "Sending" ? (
														<div className="col-md-2 ">
															<span className="badge badge-pill badge-soft-primary">{result.status}</span>
														</div>
													) : null}
													{result.status === "Email Opened" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-success">{result.status}</span>
														</div>
													) : null}
													{result.status === "Link Clicked" || result.status === "Call Picked" || result.status === "Call Received" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-warning">{result.status}</span>
														</div>
													) : null}
													{result.status === "Call Transcript" || result.status === "Chat Transcript" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-warning">{result.status}</span>
														</div>
													) : null}
													{result.status === "Data Submitted" || result.status === "Error" || result.status === "System Hacked" || result.status === "Invalid Whatsapp #" || result.status === "Invalid Telegram #" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-danger">{result.status}</span>
														</div>
													) : null}
													{result.status === "Attachment Opened" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-danger">{result.status}</span>
														</div>
													) : null}
													{result.status === "Email Reported" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-primary">{result.status}</span>
														</div>
													) : null}
													{result.status === "Replied" ? (
														<div className="col-md-2">
															<span className="badge badge-pill badge-soft-success">{result.status}</span>
														</div>
													) : null}
													<div className="col-md-2">
														<Link to={`#`} onClick={() => this.setState({ campaignTemplateId: result.campaignTemplateId, showPreview: true })}> View </Link>
													</div>
													<div className="col-md-1">
														<Link to={`#`}> View </Link>
													</div>
												</div>
											</Accordion.Toggle>
											<Accordion.Collapse eventKey={index.toString()} style={{ padding: '10px 55px', marginTop: '-14px' }}>
												<Card.Body>
													<div className="row testAccordian">
														<div className="col-md-12 activity-list">
															<h6 className="pt-3 mb-0 activity-head">Activity Timeline</h6>
															{events && events.length
																? events.map((event, index2) => {
																	var details =
																		event.message === "Error" && event.details ? JSON.parse(JSON.stringify(event.details)) : event.details;
																	if (event.message === "Attachment Opened") {
																		details = JSON.parse(event.details).info
																	}
																	return (
																		<div className="activities-history mt-4 p-0 col-md-10" key={"event-" + index2}>
																			<div
																				className={
																					events.length - 1 === index2 ? "activities-history-list last-child" : "activities-history-list"
																				}
																			>
																				<div className="activities-history-item">
																					<div className="row align-items-center">
																						<h6 className="col-md-3">
																							Activity {index2 + 1} <ArrowForwardSharpIcon className="arrow"></ArrowForwardSharpIcon>
																						</h6>
																						{event.message === "Email Sent" ||
																							event.message === "SMS Sent" ||
																							event.message === "Call Initiated" ||
																							event.message === "Sending" ||
																							event.message === "Message Sent" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-primary">{event.message}</span>
																							</div>
																						) : null}
																						{event.message === "Email Opened" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-success">{event.message}</span>
																							</div>
																						) : null}
																						{event.message === "Link Clicked" || event.message === "Call Picked" || event.message === "Call Received" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-warning">{event.message}</span>
																							</div>
																						) : null}
																						{event.message === "Call Transcript" || event.message === "Chat Transcript" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-warning">{event.message}</span>
																							</div>
																						) : null}
																						{event.message === "Data Submitted" ||
																							event.message === "Error" ||
																							event.message === "System Hacked" ||
																							event.message === "Attachment Opened" ||
																							event.message === "Invalid Whatsapp #" ||
																							event.message === "Invalid Telegram #" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-danger">{event.message}</span>
																							</div>
																						) : null}
																						{event.message === "Email Reported" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-primary">{event.message}</span>
																							</div>
																						) : null}
																						{event.message === "Replied" ? (
																							<div className="col-md-2">
																								<span className="badge badge-pill badge-soft-success">{event.message}</span>
																							</div>
																						) : null}
																						<h6 className="mb-0 col-md-5 d-flex align-items-center">
																							{getDate(event.createdAt)}
																							{details &&
																								Object.keys(details).length &&
																								(event.message === "Error" ||
																									event.message === "Data Submitted" ||
																									event.message === "System Hacked" ||
																									event.message === "Attachment Opened" ||
																									event.message === "Call Transcript" ||
																									event.message === "Chat Transcript" ||
																									event.message === "Replied") ? (
																								<Button variant="success" className="ml-2" onClick={(e) => this.onButtonClick(event.id)}>
																									View Details
																								</Button>
																							) : null}
																						</h6>
																						{/* <div className="userviewDetails" style={{ padding: '25px !important' }}>
																							{details && (typeof details === 'object'? 
																								Object.keys(details).map((key, index) => {
																									return (
																										<div className="row" key={"details-" + index}>
																											<p className="col-sm-3">{key}</p>
																											<p className="col-sm-9">{details[key]}</p>
																										</div>
																									);
																								}):
																								<div className="row">
																									{event.message === "Call Transcript" ? 
																										<AiVishingTranscript dataString={(details && JSON.parse(details)?.info || "")}/>:
																										event.message === "Chat Transcript" ?
																										<AiChatTranscript dataString={(details && JSON.parse(details)?.info || "")}/>:
																										<>
																											<p className="col-sm-3">Message</p>
																											<p className="col-sm-9">{details}</p>
																										</>
																									}
																								</div>)
																							}
																						</div> */}
																						{details &&
																							Object.keys(details).length &&
																							(event.message === "Error" ||
																								event.message === "Data Submitted" ||
																								event.message === "System Hacked" ||
																								event.message === "Attachment Opened" ||
																								event.message === "Call Transcript" ||
																								event.message === "Chat Transcript" ||
																								event.message === "Replied") ? (
																							<div className="replyWrapper">
																								<Accordion className="accordion2">
																									<Card>
																										<Accordion.Toggle
																											eventKey={index + ":" + index2}
																											className="d-none"
																											id={event.id}
																										></Accordion.Toggle>
																										<Accordion.Collapse eventKey={index + ":" + index2}>
																											<Card.Body>
																												{details && (
																													event.message === "Call Transcript" ? (
																														<AiVishingTranscript dataString={this.parseDetails(details)?.info || ""} />
																													) : event.message === "Chat Transcript" ? (
																														<AiChatTranscript dataString={this.parseDetails(details)?.info || ""} />
																													) : typeof details === 'object' ? (
																														Object.keys(details).map((key, idx) => (
																															<div className="row" key={"details-" + idx}>
																																<p className="col-sm-3">{key}</p>
																																<p className="col-sm-9">{details[key]}</p>
																															</div>
																														))
																													) : (
																														<div className="row">
																															<p className="col-sm-3">Message</p>
																															<p className="col-sm-9">{details}</p>
																														</div>
																													)
																												)}
																											</Card.Body>
																										</Accordion.Collapse>
																									</Card>
																								</Accordion>
																							</div>
																						) : null}
																					</div>
																				</div>
																			</div>
																		</div>
																	)
																})
																: null}
														</div>
													</div>
												</Card.Body>
											</Accordion.Collapse>
										</Card>
									);
								})
							) : (
								<h6 className="mt-3 ml-3"> Test result not found. </h6>
							)}
						</Accordion>
					</div>

					<div className="pagination-Wrap">
						{this.state.results && this.state.results.length ?
							<Pagination
								itemClass="page-item"
								linkClass="page-link"
								activePage={this.state.activePage}
								itemsCountPerPage={this.state.limit}
								totalItemsCount={this.state.count}
								onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
							/> : null
						}
						{this.state["loading"] ? <Loader /> : null}
					</div>
				</div>
				{this.state.showPreview ?
					<CampaignPreview
						load={() => { }}
						fromCampaign={true}
						nextPath={() => { }}
						show={this.state.showPreview}
						campaignType={this.state.campaignType}
						campaignTemplateId={this.state.campaignTemplateId}
						handleModal={() => this.setState({ showPreview: false })}
					></CampaignPreview> : ''
				}
			</div>
		);
	}
}   